import React, { FunctionComponent } from 'react'
import { Option } from '../../../components/inputs/checkboxGroup'
import { Vehicle } from '../../../core/types'
import CheckboxTrimGroup from './checkboxTrimGroup'

export interface Props {
  vehicle: Vehicle
  selectedTrimId: string
}

const TrimOptions: FunctionComponent<Props> = ({ vehicle, selectedTrimId }) => {
  if (!vehicle.trims) {
    return null
  }

  const trimOptions = (id: string) => {
    const trim = vehicle.trims.find((set) => Number(set.id) === Number(id))
    if (!trim) return []

    return trim.options.map(
      (option) =>
        ({
          label: option.name,
          value: option.id,
          checked: vehicle.selected_option_ids.includes(Number(option.id)),
        } as Option)
    )
  }

  return (
    <CheckboxTrimGroup
      name="selectedOptionsIdArray"
      options={trimOptions(selectedTrimId)}
    />
  )
}

export default TrimOptions
